import { AuditModel } from "./auditModel";

export class JobNotesModel extends AuditModel {
  public TaskReplyID: any=0;
  public TaskID: any=0;
  public JobID: any="";
  public UserID: any = "";
  public UserName: string;
  public ReplyToID: any=0;
  public ReplyToName: string="";
  public Message: any;
  public TaggedUsers: any;
}

export class Job {
  jobId: any = 0;
  JobNumber: any;
  clientId: any;
  entityId: any;
  entityTypeId: any;
  divisionId: any;
  jobTypeId: any;
  statusId: any = 0;
  financialYear: string = "";
  managerId: any = "";
  auditorId: any = "undefined";
  opportunityName: any;
  startDate: any;
  completionDate: any;
  lastContactDate: any;
  lodgementDate: any;
  jobFee: any;
  notes: string = "";
  assignUserIds: string;
  date: any;
}

export enum SystemJobsViews {
  Standard = 0,
  MyJobsThisWeek = -1,
  MyOverDueJobs = -2,
  MyJobsOnHold = -3,
  MyCompletedJobs = -4,
  Archived = -6,
}

export const PreDefinedDates = {
  "Dates": [
      {"id": 1,"name": 'All overdue',"value":'yesterday'},
      {"id": 2,"name": 'By today', "value":'today'},
      {"id": 3,"name": 'By this week',"value":'thisWeek'},
      {"id": 4,"name": 'By this month',"value":'thisMonth'},
      {"id": 5,"name": 'By next month',"value":'nextMonth'},
      {"id": 6,"name": 'By next 3 months',"value":'next3Months'},
      {"id": 7,"name": 'By this year',"value":'thisYear'},
      {"id": 8,"name": 'Custom date range',"value":'customDefaultDateRange'}
    ]
}

export const DefaultDefinedDateNames = ['today','yesterday','thisWeek','thisMonth','nextMonth','next3Months','thisYear'];

export class JobsData {
  public jobId: string;
  public jobNumber: string;
  public statusId: string;
  public clientId: string;
  public entityId: string;
  public clientName: string;
  public entityName: string;
  public entityType: string;
  public jobType: string;
  public assigneeCount: string;
  public lodgementDate: string;
  public financialYear: string;
  public statusName: string;
  public completionDate: string;
}

export class JobsDetail {
  public jobId: number;
  public jobCode: string;
  public jobTypeId: any;
  public entityType: any;
  public clientId: any;
  public jobName: string;
  public financialYear: string;
  public statusId: any;
  public jobstatusId: any;
  public scope: string;
  public divisionId: any;
  public partnerId: string;
  public managerId: string;
  public assignUserIds: string;
  public priority: string;
  public turnaround:any;
  public startDate: any;
  public dueDate: any;
  public attachFiles: any;
  public billingMethod: any;
  public quote: any;
  public estimatedHours: any;
  public customfieldsData: string;
  public selected: boolean;
  public templateId: any = 0;
  public statusOwnerId: any;
  public isJobReccurrence?: boolean = false;
  public jsonJobRecurrence?: any = null;
  public teamId:any = 0;
  public jobEstimateType: 'Job' | 'Task' = 'Job';
  public jobCategory:number;
  public debtorClientId: string;
}

export class JobsAssignUser {
  public jobId: number;
  public assignUserIds: string;
}

export class JobsDetailFilter {
  public jobTypeId: any;
  public clientId: any;
  public financialYear: string;
  public statusId: any;
  public jobstatusId: any;
  public assignUserIds: string;
  public assignedDate: any;
}

export class QueryAssignUser {
  public queryId: number;
  public assignUserIds: string;
}

export class QueryDetailFilter {
  public statusId: any;
  public dueDate: any;
}

export class CustomField {
  id: any;
  fieldType: any;
  datatype: any;
  fieldLabel: any;
  description: any;
  helpText: any;
  placeHolder: any;
  isFirstdefault: any;
  isorderedAlphabetically: any;
  sections: string;
  isReadOnly: string;
  isVisible: string;
  value: any;
  listType: any;
  customFieldValues: string;
  cfdropdown: any = [];
  groupbyHeader: any;
  isgroupby: any;
  cfcheckbox: any = [];
  showIn: Number;
}

export class UpdateCustomFieldsbyHeader {
  id: any;
  value: any;
  ival: any;
  orderedlist: any;
}

export class OrderedList {
  id: any;
  indexvalue: any;
}

export class Updatetaskorderedlist {
  id: any;
  value: any;
  ival: any;
  orderedlist: any;
}

export class JobNames {
  jobId: string;
  jobName: string;
}
export class XeroclientDetail {
  weburl: string;
  syncDate: any;
}

export class Wipdat {
  value: any;
  startDate: any;
  createdDate: any;
  jobid: any;
  writeonoff: any = 0;
}

export class Jobstatus extends AuditModel {
  statusId: any;
  jobTypeId: number;
  statusName: any
  sequence: number;
  isForQuery: any
  description: any;
  entityTypeId: any;
  statusCatId: any;
  duration: any;
  jobTypeDetails: any;
  entityTypeDetails: any;
  isTrigger: any;
}

export class Jobtype extends AuditModel {
  public jobTypeId: any = 0;
  public jobTypeName: string;
  public entityTypeName: string;
  public userName: string;
  public description: string; public defaultTemplate: any = 0;
  public entityTypeId: any;
  public divisionId: number;
  public billingValue: any;
  public isJobRecurrence: boolean = false;
  public frequency: string;
  public period: string;
  public taskCarryForward: string;
  public assigneeCarryForward: string;
  public budgetCarryForward: string;
  public statusName: string;
  public debtorJobCategory: number;
}

export class Jobtype1 extends AuditModel {
  public taskId: any = 0;
  public jobTypeId: any;
  public jobTypeName: string;
  public description: string;
}

export class TaskType extends AuditModel {
  public taskTypeId: any = 0;
  public taskType: string;
  public description: string;
  public strCreated_At: any;
  public isArchive: any = false ;
  public taskCategory: number;
}

export class JobtypewithStatus extends AuditModel {
  public lst_StatusCatNotStarted: any = [];
  public lst_StatusCatInProgress: any  = [];
  public lst_StatusCatOnHold: any  = [];
  public lst_StatusCatCompleted: any  = [];
  public lst_StatusCatReview: any = [];
  public jobTypeDetail: any = new Jobtype();
}

export class JobStatusDetailmodel {
  public StatusId: any = 0;
  public StatusCatId: any = 0;
  public StatusSequence: any = 0;
  public Description: string;
  public StatusName: string;
  public CatagoryName: string;
}

export class PostJobtypewithStatus extends AuditModel {
  public _lstremovaltemp: any  = [];
  public _lstupdatetemp: any  = [];
  public _lstnewtemp: any = [];
  public jobTypeDetail: any = new Jobtype();
}

export class JobStatusMilestone  {
  public jobId: any;
  public jobTypeId: any;
  public statusId: string;
  public statusName: string;
  public activeStatusId: any;
  public entityId: any;
  public entityTypeId: any;
  public duration: any;
  public sequency: any;
  public startDate: any;
  public dueDate: any;
}

export class Logtime {
  public logTimeId: number
  public clientId: number
  public clientName: string
  public entityName: string
  public taskName: string
  public jobName: string
  public jobType: string
  public entityId: number
  public entityTypeId: number
  public taskId: number
  public jobId: number
  public description: string
  public startTime: number
  public endTime: number
  public numberOfHours: number
  public created_By: string
  public Created_At: any
  public jobNumber: any;
  public date: any;
  public isbillable: boolean;
}

export class Myactivity extends AuditModel {
  public Id: any;
  public ClientId: any;
  public jobTypeId: any;
  public entityTypeId: any;
  public FY: any;
  public isbillable: boolean;
  public description: string;
  public userName: string;
  public isForQuery:string;
}

class Record {
  Id: number;
}

export class UpdateMissedData {
  SiteID: number;
  Type: SPJobType;
  Records: Record[];
}

export enum SPJobType {
  KloudConnect = 'KloudConnect',
  SharePoint = 'SharePoint',
  MisMatch = 'MisMatch'
}

export enum JobCategoryTypes {
  WorkFlow = 1,            // 001
  TimeSheet = 2,           // 010
  Disbursement = 4,        // 100

  WorkFlowAndTimeSheet = 1 | 2,                 // 3 - 011
  DisbursementAndWorkFlow = 4 | 1,              // 5 - 101
  DisbursementAndTimeSheet = 4 | 2,             // 6 - 110
  DisbursementTimesheetWorkflow = 1 | 2 | 4     // 7 - 111
}

export enum TaskCategoryTypes {
  WorkFlow = 1,            // 001
  TimeSheet = 2,           // 010
  NonBillable = 4,        // 100

  WorkFlowAndTimeSheet = 1 | 2,                 // 3 - 011
  NonBillableAndWorkFlow = 4 | 1,              // 5 - 101
  NonBillableAndTimeSheet = 4 | 2,             // 6 - 110
  NonBillableTimesheetWorkflow = 1 | 2 | 4     // 7 - 111
}

export enum JobCategoryTypeNames {
  WorkFlow = 'WorkFlow',
  TimeSheet = 'Time',
  Disbursement = 'Disbursement',
}

export enum WIPEntriesStatus {
  Allocated = "Allocated",
  Unallocated = "Unallocated",
  AllocatedOrPartial = "Allocated/Partial",
  Rejected = "Rejected",
  Draft = "Draft",
  Published = "Published",
  Reviewed = "Reviewed",
  Approved = "Approved",
  Cancelled = "Cancelled",
  InProgress = "In Progress",
  Completed = "Completed",
}

export interface ViewFilterBy {
  filterTagId: string | null;
  field: string;
  filterValue: any;
  filterDisplayValue: any;
  headerText: string;
  operator: string;
  predicate: 'and' | 'or';
  matchCase: boolean;
  ignoreAccent: boolean;
  type?: string;
}